import React, { useState } from "react";
import { Textarea } from "@/components/ui/textarea";
import DictateButton from "@/components/DictateButton";
import { Save } from "lucide-react";

/** Call-notes field on a CRM lead, with voice dictation. */
export const LeadNote = ({ lead, onSave }) => {
  const [open, setOpen] = useState(false);
  const [notes, setNotes] = useState(lead.notes || "");
  const dirty = notes !== (lead.notes || "");

  if (!open) {
    return (
      <div className="flex items-center gap-3 mt-2">
        <button onClick={() => setOpen(true)} data-testid={`lead-note-open-${lead.id}`}
          className="small-caps text-[10px] text-neutral-500 hover:text-[#F5B041] transition">
          {lead.notes ? "Call notes" : "+ Add call notes"}
        </button>
        {lead.notes && <span className="text-xs text-neutral-500 truncate max-w-md">{lead.notes}</span>}
      </div>
    );
  }

  return (
    <div className="mt-3 border border-white/10 p-3">
      <div className="flex items-center gap-2 mb-2">
        <span className="small-caps text-[10px] text-neutral-500">Call notes</span>
        <span className="ml-auto flex items-center gap-2">
          <DictateButton testId={`lead-note-dictate-${lead.id}`} label="Dictate"
            context="A Chef Hire concierge dictating notes from a call with a prospective client about private chefs or catering."
            onText={(t) => setNotes((p) => [p.trim(), t].filter(Boolean).join(" "))} />
          <button onClick={() => { onSave(lead.id, notes); setOpen(false); }} disabled={!dirty}
            data-testid={`lead-note-save-${lead.id}`}
            className="inline-flex items-center gap-1 small-caps text-[10px] px-3 h-7 border border-white/10 hover:border-[#F5B041]/50 disabled:opacity-40 transition">
            <Save size={11} /> Save
          </button>
        </span>
      </div>
      <Textarea value={notes} onChange={(e) => setNotes(e.target.value)} data-testid={`lead-note-input-${lead.id}`}
        placeholder="What was discussed, next step, quoted price…"
        className="rounded-none bg-transparent border-white/10 min-h-20 text-sm" />
    </div>
  );
};

export default LeadNote;
